import { QuoteIcon } from 'lucide-react';
import AuthorCard from './AuthorCard';

export default function TestmonialCard({
  description,
  author,
  companyLogo,
}: {
  description: string;
  author: { name: string; role: string; image: string };
  companyLogo: string;
}) {
  return (
    <div className="bg-gray flex h-full flex-col justify-between gap-4 p-10">
      <QuoteIcon className="text-darkBlue text-[40px] opacity-50" />
      <p className="text-lighterBlack py-10 text-[19px] font-light">{description}</p>
      <div className="flex items-center justify-between gap-4">
        <AuthorCard name={author.name} role={author.role} image={author.image} />
        <img
          src={companyLogo}
          alt={`${author.name} - ${author.role}`}
          className={`${companyLogo.includes('1') ? 'w-14' : 'w-32'}`}
        />
      </div>
    </div>
  );
}
